import React from "react";

const Assets = ({ array, name }) => {
	return (
		<>
			<h3>{name}</h3>

			<ul className="players">
				{array.map((item, index) => {
					return item.file ? (
						<li key={index}>
							<a href={item.file} download>
								<img className="image-shadow" src={item.img} alt={item.name} />
							</a>
							<div className="name-appearances">
								{item.name}
								<br />
								<a href={item.file} download>
									Download ({item.format})
								</a>
							</div>
						</li>
					) : (
						<li key={index}>
							<a href={item.url} target="_blank" rel="noopener noreferrer">
								<img className="image-shadow" src={item.img} alt={item.name} />
							</a>
							<div className="name-appearances">
								{item.name}
								<br />
								<a href={item.url} target="_blank" rel="noopener noreferrer">
									View ({item.format})
								</a>
							</div>
						</li>
					);
				})}
			</ul>

			<div className="list-spacer"></div>
		</>
	);
};

export default Assets;
